import React from 'react'
import Dashnav from '../Components/Dashnav'
import Leftmenu from '../Components/Leftmenu'
import TeamsComp from './TeamsComp'

function TheTeams() {
  return (
    <div>
        <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <TeamsComp/>
     
            </div>
        </div>  
    </div>
  )
}

export default TheTeams